import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Flame } from "lucide-react";

/**
 * StreakWidget — daily reporting streak for the current consultant.
 * Rules (set by the user):
 *   - Reporting any day counts toward the streak
 *   - Today is a grace day (not reported yet ≠ broken)
 *   - Missing a weekday (Mon-Fri) other than today BREAKS the streak
 *   - Missing a weekend day (Sat/Sun) is NEUTRAL
 */
export default function StreakWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/streak/me")
      .then((r) => setData(r.data))
      .catch((e) => console.debug("streak fetch failed:", e?.message));
  }, []);

  if (!data || !data.enabled) return null;

  const { current_streak, longest_streak, last_reported_date } = data;
  const flame = current_streak >= 21 ? "🔥🔥🔥" : current_streak >= 7 ? "🔥🔥" : current_streak >= 3 ? "🔥" : "";
  const tone = current_streak === 0
    ? { color: "#737373", bg: "#1A1A1A", title: "Sem streak — começa hoje", help: "Reporta hoje para começar uma série." }
    : current_streak >= 21
    ? { color: "#EAB308", bg: "rgba(234,179,8,0.05)", title: "Streak Lendária", help: "Mantém o ritmo!" }
    : current_streak >= 7
    ? { color: "#E50000", bg: "rgba(229,0,0,0.05)", title: "Streak Forte", help: "Hábito instalado." }
    : { color: "#3B82F6", bg: "rgba(59,130,246,0.05)", title: "Streak em construção", help: "Continua dia após dia." };

  return (
    <div className="kw-card p-5 border" style={{ borderColor: tone.color + "55", background: tone.bg }} data-testid="streak-widget">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <Flame className="w-7 h-7" style={{ color: tone.color }} />
          <div>
            <div className="kw-overline" style={{ color: tone.color }}>{tone.title}</div>
            <div className="font-display text-4xl font-black" data-testid="streak-current">
              {current_streak}
              {flame && <span className="ml-2 text-2xl align-middle">{flame}</span>}
              <span className="text-base font-normal text-[#A3A3A3] ml-2">
                {current_streak === 1 ? "dia" : "dias"} seguidos
              </span>
            </div>
          </div>
        </div>
        <div className="text-right text-xs">
          <div className="text-[10px] uppercase tracking-widest text-[#737373]">Recorde pessoal</div>
          <div className="font-display text-xl font-black" data-testid="streak-longest">{longest_streak}</div>
          {last_reported_date && (
            <div className="text-[10px] text-[#737373] mt-1">Último: {formatShort(last_reported_date)}</div>
          )}
        </div>
      </div>
      <p className="text-[10px] uppercase tracking-widest text-[#737373] mt-3">
        {tone.help} · Fim-de-semana é neutro · Falhar 1 dia de semana (Seg–Sex) reinicia.
      </p>
    </div>
  );
}

function formatShort(iso) {
  try { return new Date(iso + "T00:00:00").toLocaleDateString("pt-PT", { day: "2-digit", month: "short" }); }
  catch { return iso; }
}
